import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import getBaseUrl from './BaseUrl';

@Injectable()
export class ClientTokenService {
  clientToken$: Observable<string>;
  private clientTokenSubject = new Subject<string>();

  constructor(private http: HttpClient) {
    this.clientToken$ = this.clientTokenSubject.pipe(
      map((clientToken: string) => clientToken)
    );
  }

  pushClientToken(clientToken: string) {
    this.clientTokenSubject.next(clientToken);
  }

  validateClientToken(clientToken: string): Observable<HttpResponse<object>> {
    const url = `${getBaseUrl()}api/auth`;
    return this.http.get(url, {
      headers: new HttpHeaders({
        Authorization: `Bearer ${clientToken}`,
        'Content-Type': 'application/json'
      }),
      observe: 'response'
    });
  }
}
